import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ChatSettings } from 'types/chatSettings';

const initialState: ChatSettings = {
  additional: [],
  jurisdiction: null,
  mode: 'single',
  models: ['default'],
  mainModel: null,
  themeOptions: {},
};

const chatSettingsSlice = createSlice({
  name: 'chatSettings',
  initialState,
  reducers: {
    setChatSettingsAdditional: (
      state,
      action: PayloadAction<ChatSettings['additional']>,
    ) => {
      state.additional = action.payload || [];
    },
    setChatSettingsJurisdiction: (
      state,
      action: PayloadAction<ChatSettings['jurisdiction']>,
    ) => {
      state.jurisdiction = action.payload || null;
    },
    setChatSettingsMode: (
      state,
      action: PayloadAction<ChatSettings['mode']>,
    ) => {
      state.mode = action.payload ?? initialState.mode;
    },
    setChatSettingsModels: (
      state,
      action: PayloadAction<ChatSettings['models'] | undefined>,
    ) => {
      state.models = action.payload ?? initialState.models;
    },
    setChatSettingsMainModel: (
      state,
      action: PayloadAction<ChatSettings['mainModel']>,
    ) => {
      state.mainModel = action.payload ?? initialState.mainModel;
    },
    setChatSettingsThemeOptions: (
      state,
      action: PayloadAction<ChatSettings['themeOptions']>,
    ) => {
      state.themeOptions = action.payload || {};
    },
  },
});

export const {
  setChatSettingsAdditional,
  setChatSettingsJurisdiction,
  setChatSettingsMode,
  setChatSettingsModels,
  setChatSettingsMainModel,
  setChatSettingsThemeOptions,
} = chatSettingsSlice.actions;
export default chatSettingsSlice.reducer;
